import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export interface PartnerInfo {
  pid: string;
  requestId: string;
  apiKey: string | null;
  addChannelSource: string | null;
  overrideChannelSource: string | null;
  language: string | null;
  currency: string | null;
}

const useUrlInfo = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const addChannelSource = queryParams.get('addChannelSource');
  const overrideChannelSource = queryParams.get('overrideChannelSource') ?? queryParams.get('overRideChannelSource');

  const langFromQuery = queryParams.get('lang');
  const currencyFromQuery = queryParams.get('currency');

  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing,unicorn/prefer-logical-operator-over-ternary, no-unneeded-ternary
  const language = langFromQuery ? langFromQuery : null;
  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing, unicorn/prefer-logical-operator-over-ternary, no-unneeded-ternary
  const currency = currencyFromQuery ? currencyFromQuery : null;

  const urlBeforePartner = /.*\/partner/; // use a variable to avoid sonarcloud error

  return useMemo<{ states: PartnerInfo }>(() => {
    if (location.pathname.includes('/partner') && location.pathname.includes('/channel')) {
      // eslint-disable-next-line no-unused-vars, unused-imports/no-unused-vars, @typescript-eslint/no-unused-vars, sonarjs/no-unused-vars
      const [pid, _apiKeyNode, apiKey] = location.pathname.replace(urlBeforePartner, '').split(/\//g).slice(1);

      return {
        states: {
          pid,
          requestId: '',
          apiKey,
          addChannelSource,
          overrideChannelSource,
          language,
          currency,
        },
      };
    } else if (location.pathname.includes('/partner')) {
      const [pid, requestId] = location.pathname.replace(urlBeforePartner, '').split(/\//g).slice(1);

      return {
        states: {
          pid,
          requestId,
          apiKey: null,
          addChannelSource,
          overrideChannelSource,
          language,
          currency,
        },
      };
    }
    return {
      states: {
        pid: '',
        requestId: '',
        apiKey: null,
        addChannelSource,
        overrideChannelSource,
        language,
        currency,
      },
    };
  }, [location.pathname, location.search]);
};

export default useUrlInfo;
